
import React from "react"
import { useEffect } from 'react';
import hotelcss from './css/hotelhotellist.module.css';
import { useState } from 'react'
import { setErrorMessage } from "../tools/errorhandling";
import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import {
    sendhoteldata, getallhotels, gethotel,
    updateHotelData, getRooms, getRoomsTypes,
    getserverurl, createroom, createroomtype, createfloor,
    editkamer, deleteRoom, deleteRoomtype, editkamerType, saveCleaningtask, getCleaningtasks, editCleaningTask, deleteCleaningTask,
    saveCleaningtype, getCleaningtypes, editCleaningType, deleteCleaningType, savelinkedTasks, getlinkedtasks
} from "../dbconnector/connector";
import TariefNode from '../customNodes/TariefNode';


const Tarieven = (props) => {
    const t = props.translation
    const [selectedhotel, setselectedhotel] = useState([]);
    const [hotels, sethotels] = useState([]);
    const [CleaningTypes, setCleaningTypes] = useState({});
    const [cleaningtypearray, setcleaningtypearray] = useState([]);
    const [fieldDisabled, setfieldDisabled] = useState(true);
    const navigate = useNavigate();
        const prevCSS = React.useRef(0)
        const prevSelectedRecord = React.useRef(0)

    useEffect(() => {
        try {
            const hotels = getallhotels();
            hotels.then((hotellist) => {
                //////console.log(hotellist)
                if (hotellist.status === 200) {
                    sethotels(hotellist.items)
                    //

                    const ZoekOpNaam = document.getElementById("ZoekOpNaam");
                    const ZoekOpAfNr = document.getElementById("ZoekOpAfNr");
                    const active = document.getElementById("activehotel");
                    active.addEventListener("click", function (e) {
                        filter(hotellist)
                    })

                    ZoekOpNaam.addEventListener("input", function (e) {
                        filter(hotellist)
                    })

                    ZoekOpAfNr.addEventListener("input", function (e) {
                        filter(hotellist)
                    })
                    active.checked = "true"
                    Createhotelslist(hotellist.items, navigate,fieldDisabled);

                } else {
                    setErrorMessage("Error while retrieving hotels")
                }

            })

        } catch (error) {
            setErrorMessage("Error while retrieving hotels")
        }


    }, []);

   

    function filter(hotellist) {
        const ZoekOpNaam = document.getElementById("ZoekOpNaam")
        const ZoekOpAfNr = document.getElementById("ZoekOpAfNr")
        const filteredhotels = hotellist.items.filter(element => {
            if (element.Name.toLowerCase().includes(ZoekOpNaam.value.toLowerCase()) && element.nr_afd.toString().includes(ZoekOpAfNr.value)) {
                return element
            }
        })
        Createhotelslist(filteredhotels, navigate, fieldDisabled)
    }


    const Createhotelslist = (hotellist, navigate) => {

        let listForHotels = document.getElementById("hotelsList");
        if (listForHotels === null) {
            listForHotels = document.createElement("div");
            listForHotels.id = "hotelsList";
            const upperdiv = document.getElementById("main");
            upperdiv.appendChild(listForHotels);
        } else {
            listForHotels.innerHTML = ""
        }

        const hotellistactivefilter = hotellist.filter(element => !document.getElementById("activehotel").checked ? element.active === 0 : element.active === 1)

        hotellistactivefilter.forEach((hotel, index) => {

            const hotellink = document.createElement("div");
            //addname element to div
            hotellink.id =  hotel.Hotel_ID;
            const IdP = document.createElement("p");
            IdP.className = hotelcss.textalignright;
            IdP.innerText = hotel.nr_afd;
            hotellink.appendChild(IdP);
            const nameP = document.createElement("p");
            nameP.innerText = hotel.Name;
            hotellink.appendChild(nameP);
            const description = document.createElement("p");
            description.innerText = hotel.straatnaam + " " + hotel.huisnummer + ", " + hotel.zipcode + " " + hotel.gemeente;
            hotellink.appendChild(description);

            //dinamicly add classname
            if (index % 2 === 0) {
                hotellink.className = hotelcss.linkVarient1
            } else {
                hotellink.className = hotelcss.linkVarient2
            }
            hotellink.addEventListener('click', function (e) {
                selectRate(hotel);
//                setselectedhotel(hotel);
            });
            listForHotels.appendChild(hotellink)
        });
    }

    
    function selectRate(hotel) {
        //console.log(hotel)
        if (prevCSS.current !== undefined && prevSelectedRecord.current !== undefined) {
            if (document.getElementById(prevSelectedRecord.current)) {
                document.getElementById(prevSelectedRecord.current).className = prevCSS.current;
            }
        }
        prevCSS.current = document.getElementById(hotel.Hotel_ID).className;
        prevSelectedRecord.current = hotel.Hotel_ID
        //console.log("hotel = ", hotel)
        document.getElementById(hotel.Hotel_ID).className = hotelcss.linkVarientSelectedRow
        setselectedhotel(hotel);
        //console.log("hotel = ", hotel)
    }


    return (
        <>
            <div id="main">
                <header>
                    <div id="errordiv" className='error'>
                    </div>
                </header>

                <div id="filters" className="form" >
                    <label className='formtitleContentBox'>{t('filterinstellingen')}</label>
                    <br></br>
                    <div className="contentbox">
                        <div className="formElement">
                            <label className='labelcolor'>
                                {t('Active')}
                            </label>
                            <input type="checkbox" id="activehotel" className="checkbox"></input>
                        </div>
                        <div className="formElement">
                            <label className='labelcolor'>
                                {t('HotelName')}:
                            </label>
                            <input type="text" id="ZoekOpNaam" placeholder="Search"></input>
                        </div>
                        <div className="formElement">
                            <label className='labelcolor'>
                            {t('NR_Dep')}:
                            </label>
                            <input type="text" id="ZoekOpAfNr" placeholder="Search"></input>
                        </div>

                    </div>
                    <div id="headertabled" className={hotelcss.tableheader}><p id="status">{t('NR_Dep')}</p><p id="type">{t('Name')}</p><p id="senddate">{t('Address')}</p></div>

                    <div id="hotelsList" className="selectionlist">
                    </div>
                    <TariefNode rights={props.rights} t={t} disabled={true} hotel={{selectedhotel}} events={{setErrorMessage:setErrorMessage}} css={hotelcss} />
                </div>
            </div>

        </>

    )

}

export default Tarieven